import { Http } from '../data/http';
import { formValues } from '../forms/form';

// initializes new map by default
export function initiateMap(latValue, lngValue) {
    let map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: latValue, lng: lngValue},
        zoom: 17
    });
    let marker = new google.maps.Marker({
        map: map,
      });
    marker.setPosition({lat: latValue, lng: lngValue});
    marker.setVisible(true);
}

// creates a new map based on location user selects
export function createNewMap(selector, lat, lng) {
    let mapElement = document.querySelector('#map');
    let container = selector.querySelector('.map-container');
    if (!mapElement) {
        mapElement = document.createElement('div');
        mapElement.setAttribute('id', 'map');
    }
    container.appendChild(mapElement);
    initiateMap(lat, lng);
}

// calls more locations if "Load More" is clicked
export function loadMore(address) {
    let selector = document.querySelector('.load-more-container');
    let clicks = 0;
    let count = 4; 

    //remove event listener by cloning
    recreateNode(selector.querySelector('.load-more-btn'));

    selector.querySelector('.load-more-btn').addEventListener('click', function() {
        let url = window.location.origin;
        let request = new Http(url);

        let facilityForm = document.querySelector('.facility-form');
        facilityForm.querySelector('.form-group').classList.remove('invalid');
        
        let loadingGif = document.querySelector('.loading-gif');

        clicks += 1;
        count += 4;

        if (clicks <= 3) {
            removePreviousSearchResults();

            gtag("event", "Y Affiliation Endpoint Request Start", {
                "event_category": "Engagement",
                "event_label": ""
            });

            request.get('/api/locations?ResultCount=' + count + '&RowOffset=0' + "&Address=" + address + "&ReturnAllOpenYs=true")
                .then(res => createLocations(res))
                .then(res => {
                    loadingGif.classList.add('hide');
                    gtag("event", "Y Affiliation Endpoint Response Success", {
                        "event_category": "Engagement",
                        "event_label": ""
                    });
                })
                .catch(_ => {
                    gtag("event", "Y Affiliation Endpoint Response Failure", {
                        "event_category": "Engagement",
                        "event_label": ""
                    });
                });
        } else {
            selector.querySelector('.load-more-btn').classList.add('hide');
            selector.querySelector('.disclaimer').classList.remove('hide');
        }  
    });
}

export function recreateNode(el, withChildren) {
    if (withChildren) {
      el.parentNode.replaceChild(el.cloneNode(true), el);
    }
    else {
      var newEl = el.cloneNode(false);
      while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
      el.parentNode.replaceChild(newEl, el);
    }
  }

// adds styling to locations that are not selected (i.e. are grayed out)
export function removeSelectedLocations() {
    let results = document.querySelectorAll('.location-result');
    for (let i = 0; i < results.length; i++) {
        results[i].classList.add('not-selected');
        results[i].classList.remove('selected-location');
    }
}

// removes previous locations
// this is when a user goes from putting in an address then clicking "Current Location" - previous results need to be cleared
export function removePreviousSearchResults() {
    let parent = document.querySelector(".location-results");
    let selector = document.querySelector('.load-more-container');
    if (selector.querySelector('.load-more-btn').classList.contains('hide')) {
	    selector.querySelector('.load-more-btn').classList.remove('hide');
    }
	if (!selector.querySelector('.disclaimer').classList.contains('hide')) {
        selector.querySelector('.disclaimer').classList.add('hide');
    }
    
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
}

// all logic for when user clicks "Current Location"
export function launchGeolocation() {
    let tab = document.querySelector('.launch-location');

    tab.addEventListener('click', function(e) {
      // prevent double clicks
      if (!e.detail || e.detail == 1) {
        if (navigator.geolocation) {
            let loadingGif = document.querySelector('.loading-gif');
            let facilityForm = document.querySelector('.facility-form');
            facilityForm.querySelector('.button').innerHTML = 'Select a location';
            facilityForm.querySelector('.form-group').classList.remove('invalid');

            loadingGif.classList.remove('hide');
            navigator.geolocation.getCurrentPosition((loc => {
                if (loc.coords) {
                    removePreviousSearchResults();
                    let googleMapPosition = new google.maps.LatLng(loc.coords.latitude, loc.coords.longitude)
                    let geocode = new google.maps.Geocoder();

                    geocode.geocode(
                        {'latLng': googleMapPosition},
                        function(results, status) {
                            let url = window.location.origin;
                            let request = new Http(url);
                            let address = results[0].formatted_address.replace(/\s/g, '');
                            loadMore(address);
                            let selector = document.querySelector('.load-more-container');
            
                            gtag("event", "Y Affiliation Endpoint Request Start", {
                                "event_category": "Engagement",
                                "event_label": ""
                            });
                            request.get('/api/locations?ResultCount=4&RowOffset=0&Address=' + address + "&ReturnAllOpenYs=true")
                                .then(res => createLocations(res))
                                .then(res => {
                                    selector.classList.remove('hide');
                                    loadingGif.classList.add('hide');
                                    gtag("event", "Y Affiliation Endpoint Response Success", {
                                        "event_category": "Engagement",
                                        "event_label": ""
                                    });
                                })
                                .catch(_ => {
                                    gtag("event", "Y Affiliation Endpoint Response Failure", {
                                        "event_category": "Engagement",
                                        "event_label": ""
                                    });
                                })
                        }
                    )
                }
            }))
        } else {
            console.log('Geolocation is not supported by this browser.');
        }
      }
    })
  }

  // all logic for when a user types in a location into the input field
  export function searchFieldLocation() {
    let geolocation = document.getElementById('geolocation');
    let autocomplete = new google.maps.places.Autocomplete(geolocation);

    geolocation.addEventListener('keydown', function(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    });

    autocomplete.addListener('place_changed', function() {
        let place = autocomplete.getPlace();
        
        if (place.geometry.location) {
            removePreviousSearchResults();
            let loadingGif = document.querySelector('.loading-gif');
            loadingGif.classList.remove('hide');
            let url = window.location.origin;
            let request = new Http(url);
            let address = place.formatted_address.replace(/\s/g, '');

            loadMore(address);

            let selector = document.querySelector('.load-more-container');

            gtag("event", "Y Affiliation Endpoint Request Start", {
                "event_category": "Engagement",
                "event_label": ""
            });
            request.get('/api/locations?ResultCount=4&RowOffset=0&Address=' + address + "&ReturnAllOpenYs=true")
                .then(res => createLocations(res))
                .then(res => {
                    selector.classList.remove('hide');
                    loadingGif.classList.add('hide');
                    gtag("event", "Y Affiliation Endpoint Response Success", {
                        "event_category": "Engagement",
                        "event_label": ""
                    });
                })
                .catch(_ => {
                    gtag("event", "Y Affiliation Endpoint Response Failure", {
                        "event_category": "Engagement",
                        "event_label": ""
                    });
                })
        }
    });
}

// dynamically creates HTML based on API results for each location
export function createLocations(results) {
	let locations = results.items;
    let container = document.querySelector('.location-results');
    container.innerHTML = '';
	for (let i = 0; i < locations.length; i++) {
        let result = document.createElement('div');
        result.setAttribute('class', 'location-result');
        result.setAttribute('id', locations[i].id);

        let facilityForm = document.querySelector('.facility-form');
        facilityForm.querySelector('.button').classList.add('disabled');

		let divider = document.createElement('div');
		divider.setAttribute('class', 'divider');

		let content = document.createElement('div');
		content.setAttribute('class', 'content');

		let imageContainer = document.createElement('div');
		imageContainer.setAttribute('class', 'image-container')

        // uncomment if client decides to add images back
		// let check = document.createElement('img');
		// check.setAttribute('class', 'checkmark');
		// check.setAttribute('src', '/checkmark.png');

		// let locationImage = document.createElement('img');
		// locationImage.setAttribute('class', 'location-image');
		// locationImage.setAttribute('src', '/Y-Logo.png');

		// imageContainer.appendChild(check);
		// imageContainer.appendChild(locationImage);
		// content.appendChild(imageContainer);

		let textContainer = document.createElement('div');
		textContainer.setAttribute('class', 'text-container')

		let headline = document.createElement('div');
		headline.setAttribute('class', 'headline');

        let name = document.createElement('p');
        name.setAttribute('class', 'location-name')
		name.innerHTML = locations[i]['name'];

		let miles = document.createElement('span');
		miles.innerHTML = "(" + locations[i]["distance"] + " miles)";

		headline.appendChild(name);
		headline.appendChild(miles);
		textContainer.appendChild(headline);

		let address = document.createElement('p');
		address.setAttribute('class', 'address');

		address.innerHTML = locations[i]['address']['street1'] + ", " + locations[i]['address']['city'] + ', ' + locations[i]['address']['state'];

		textContainer.appendChild(address);
		content.appendChild(textContainer);

		let mapContainer = document.createElement('div');
		mapContainer.setAttribute('class', 'map-container');

		let dividerBottom = document.createElement('div');
		dividerBottom.setAttribute('class', 'divider divider-bottom');

		result.appendChild(divider);
		result.appendChild(content);
		result.appendChild(mapContainer);
		result.appendChild(dividerBottom);

        container.appendChild(result);

		result.addEventListener('click', function() {
			if (result.classList.contains('selected-location')) {
				return false;
			} else {
                let selector = document.querySelector('.load-more-container');
                if (!selector.classList.contains('hide')) {
                    selector.classList.add('hide');
                }
                createNewMap(result, locations[i]['latitude'], locations[i]['longitude']);
                removeSelectedLocations();

                formValues["location"] = result.querySelector('.location-name').innerHTML;
                formValues["associationNumber"] = result.id;

				result.classList.remove('not-selected');
                result.classList.add('selected-location');
                
                let assnNumField = document.getElementById('assn_number');
                if (assnNumField) {
                    assnNumField.value = locations[i]['id'];
                }

                let facilityForm = document.querySelector('.facility-form');
                facilityForm.querySelector('.form-group').classList.remove('invalid');
                facilityForm.querySelector('.button').classList.remove('disabled');
                facilityForm.querySelector('.button').innerHTML = 'Continue';
			}
		})
	}
}
